export default (state, type) => {
  let modal = state.modal.filter(modal => modal.modalType === type);
  return modal[0];
};
